/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import createMedliTerm from '../../models/MedliTermCompose';
import { useActiveUser } from '../hooks/useUser';

interface MedliTermProps {
  languageCode?: string;
  medliTerm: any;
  style?: any;
  className?: string;
}
const MedliTerm: React.FC<MedliTermProps> = (props) => {
  const [{ preferredLanguageCode }] = useActiveUser();

  const languageCode = props.languageCode || preferredLanguageCode;
  const term: any = createMedliTerm(props.medliTerm, languageCode);
  return (
    <span className={props.className} style={props.style}>
      {term.formattedTermName()}
    </span>
  );
};

export default MedliTerm;
